import PopupActions from '../../../actions/PopupActions';

import PopupStore from '../../../stores/PopupStore';

class JournalEntries extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            filter : ''
        };

        this.onFilterChange = this.onFilterChange.bind(this);
        this.onSelect = this.onSelect.bind(this);
    }

    onFilterChange(e) {
        this.setState({ filter : e.target.value });
    }

    onPopupStoreChange(e) {
        this.setState({ filter : e.target.value });
    }

    onSelect(note) {
        if (this.props.selected && this.props.selected.NoteId === note.NoteId) {
            note = false;
        }

        this.props.onSelect(note);
    }

    render() {
        var self     = this;
        var notes    = this.props.notes;
        var selected = this.props.selected;
        var filter   = this.state.filter;

        return (
            <div className='journal-entries'>

                <i
                    className='fa fa-plus'
                    aria-hidden='true'
                    title='Add new note'
                    onClick={ this.onSelect.bind(this, false) } />

                <i
                    className='fa fa-refresh'
                    aria-hidden='true'
                    title='Re-fresh notes'
                    onClick={() => { this.props.onRefresh(); }} />


                <input
                    type='text'
                    placeholder='Search notes...'
                    className='input-text-1'
                    value={this.state.filter}
                    onChange={this.onFilterChange} />

                <div className='journal-entries__list'>
                    <table className='table-1'>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Subject</th>
                                <th>Action</th>
                                <th>By</th>
                            </tr>
                        </thead>
                        <tbody>
                            { notes.map((note, i) => {

                                if (filter.length > 0) {
                                    if (note.NoteSubject.toLowerCase().indexOf(filter.toLowerCase()) === -1) {
                                        return;
                                    }
                                }

                                return (
                                    <tr
                                        className={selected && selected.NoteId === note.NoteId ? 'table-1__selected' : ''}
                                        onClick={self.onSelect.bind(self, note)}
                                        key={note.NoteId}>

                                        <td>{moment(note.NoteDate).format('DD MMM Y')}</td>
                                        <td>{note.NoteSubject.substring(0, 42)}</td>
                                        <td>{note.NoteAcctView}</td>
                                        <td>{note.NoteUserName}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default JournalEntries;


//                <i className='fa fa-file-excel-o' aria-hidden='true' title='Export' />



// WEBPACK FOOTER //
// ./ui_src/app/components/popup/journal/JournalEntries.react.jsx